var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 23C3 11.9543 11.9543 3 23 3C34.0457 3 43 11.9543 43 23C43 34.0457 34.0457 43 23 43C11.9543 43 3 34.0457 3 23Z",
    fill: "#D1FADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 22.2335V23.0002C31.3324 24.7972 30.7505 26.5458 29.6745 27.9851C28.5986 29.4244 27.0862 30.4773 25.3629 30.9868C23.6396 31.4963 21.7978 31.4351 20.1121 30.8124C18.4265 30.1896 16.9873 29.0386 16.0092 27.5311C15.0311 26.0236 14.5666 24.2403 14.6848 22.4471C14.8031 20.654 15.4978 18.9472 16.6653 17.5811C17.8329 16.2151 19.4107 15.263 21.1636 14.867C22.9164 14.471 24.7503 14.6522 26.3918 15.3835M31.3334 16.3335L23.0001 24.6752L20.5001 22.1752",
    stroke: "#039855",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 40C13.6112 40 6 32.3888 6 23H0C0 35.7025 10.2975 46 23 46V40ZM40 23C40 32.3888 32.3888 40 23 40V46C35.7025 46 46 35.7025 46 23H40ZM23 6C32.3888 6 40 13.6112 40 23H46C46 10.2975 35.7025 0 23 0V6ZM23 0C10.2975 0 0 10.2975 0 23H6C6 13.6112 13.6112 6 23 6V0Z",
    fill: "#ECFDF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.1acec4c705cb771e4cef6bfb500524e0.svg";
export { ForwardRef as ReactComponent };